export enum AccessLevel {
  UNDEFINED = 'UNDEFINED',
  PRIVATE = 'PRIVATE',
  SHARED = 'SHARED',
  PUBLIC = 'PUBLIC',
}
